<div [hidden]="!message" class="mb-lg-10 mt-lg-0 my-5 alert alert-custom alert-{{type}} alert-dismissible">
  <div class="alert-text" [innerHTML]="message"></div>
</div>
